// Flerpie's desktop dock: the panel on the left, the launcher in the nav, and the page
// giving up the panel's width. docs/features/flerpie-panel.md.

/** The docked panel's id, for the launcher's aria-controls. */
export const FLERPIE_PANEL_ID = 'flerpie-panel';

/**
 * The timing for anything that moves with the dock. The panel docks on the LEFT and writes its
 * width to `--flerpie-dock` on <html> (unset when closed), flagging `data-flerpie-dock` and
 * `data-flerpie-side="left"` there; a left-anchored surface offsets by `var(--flerpie-dock,0px)` and pairs this with `transition-[<property>]`.
 * In on the spring with the panel, out on the exit, and a jump while the edge is dragged or
 * under reduced motion.
 */
export const DOCK_MOTION =
  'duration-exit ease-exit motion-reduce:transition-none [html[data-flerpie-dock=open]_&]:duration-spring [html[data-flerpie-dock=open]_&]:ease-spring [html[data-flerpie-dock=resizing]_&]:transition-none';

/** The nav renders a launcher per breakpoint; focus goes to the one on screen. */
export function focusLauncher(): void {
  const launchers = Array.from(document.querySelectorAll<HTMLElement>('[data-flerpie-launcher]'));
  launchers.find((el) => el.getClientRects().length > 0)?.focus({ preventScroll: true });
}
